import { SupportedImageTypes, SupportedVideoTypes } from "./file.constant";

interface FileChecking {
  file: File;
  supportedTypes?: string[];
}

const fileChecking = ({
  file,
  supportedTypes = SupportedImageTypes.concat(SupportedVideoTypes),
}: FileChecking) => {
  if (!supportedTypes.includes(file.type)) {
    return false;
  }

  return true;
};

const FileHelper = { fileChecking };

export default FileHelper;
